import { FormGroup, FormSection } from '@ksyos/design-system';
import type { IServiceEmployment } from '@frontend/components/interfaces/serviceEmployment';
import type { IServiceConsumer } from '../../../interfaces/serviceConsumer';
import type { IServiceProvider } from '../../../interfaces/serviceProvider';
import type { IServiceReaderWithServices } from '../../../interfaces/serviceReader';
import type { IServiceSupervisor } from '../../../interfaces/serviceSupervisor';
import { translateKey } from '../../../../translate';
import { FormattedDate } from '../../../userDataManagement/FormattedDate';

interface IDateSettingsProps {
    serviceRight:
        | IServiceReaderWithServices
        | IServiceSupervisor
        | IServiceProvider
        | IServiceConsumer
        | IServiceEmployment;
}

export function DateSettings(props: IDateSettingsProps) {
    return (
        <FormSection>
            <FormGroup label={translateKey('common.startingDate')}>
                <FormattedDate value={props.serviceRight.startDate} />
            </FormGroup>

            <FormGroup label={translateKey('common.endDate')}>
                <FormattedDate value={props.serviceRight.endDate} />
            </FormGroup>
        </FormSection>
    );
}
